import { IconBrandAmazon, IconPhoto, IconVideo } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { type AdFormat, FORMAT_KEYS } from "./sponsored-brands-model";

export function AdFormatPicker({
  adFormat,
  onSelect,
}: {
  adFormat: AdFormat;
  onSelect: (format: AdFormat) => void;
}) {
  const { t } = useTranslation("campaignCreation");
  return (
    <>
      <div className="grid grid-cols-3 gap-5">
        {FORMAT_KEYS.map((value) => (
          <FormatCard key={value} value={value} selected={adFormat === value} onSelect={onSelect} />
        ))}
      </div>
      <p className="text-sm text-muted-foreground">
        {t(`sb.format.help.${adFormat}`)}{" "}
        <span className="text-primary">{t("sb.format.creativeServices")}</span>
      </p>
    </>
  );
}

function FormatCard({
  value,
  selected,
  onSelect,
}: {
  value: AdFormat;
  selected: boolean;
  onSelect: (format: AdFormat) => void;
}) {
  const { t } = useTranslation("campaignCreation");
  const Icon =
    value === "video" ? IconVideo : value === "storeSpotlight" ? IconPhoto : IconBrandAmazon;
  return (
    <Button
      type="button"
      variant="outline"
      aria-label={t(`sb.format.${value}.title`)}
      aria-pressed={selected}
      onClick={() => onSelect(value)}
      className={cn(
        "h-52 flex-col justify-between whitespace-normal p-4",
        selected && "border-primary ring-2 ring-primary/15",
      )}
    >
      <span className="text-lg font-semibold">{t(`sb.format.${value}.title`)}</span>
      <Icon className="size-16 text-primary/70" />
      <span className="text-center text-sm font-normal text-muted-foreground">
        {t(`sb.format.${value}.description`)}
      </span>
      <span
        className={cn(
          "size-4 rounded-full border",
          selected && "border-primary bg-primary shadow-[inset_0_0_0_3px_var(--background)]",
        )}
      />
    </Button>
  );
}
